// External
import _ from "lodash";

// Graphql & Redux
import { store } from "store/createStore";
import client from "lib/apolloClient/client";

// Fragments
import { getUIElementsQuery } from "./HomePageQueries";

export const readHomepageFeatureDataFromCache = ({ key }) => {
  try {
    const state = store.getState();

    const selectedAcademicYear = _.get(
      state,
      "platform.academicYearSelected",
      {}
    );

    const data = client.readQuery({
      query: getUIElementsQuery,
      variables: {
        filters: {
          academicYearSelected: _.get(selectedAcademicYear, "id", null),
        },
      },
    });

    const uiElements = _.get(data, "platform.uiElements");

    return _.find(uiElements, { key }) || {};
  } catch (e) {
    return {};
  }
};
